import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiConfiguration } from '@klubovna/api-client';
import { productsControllerCreate } from '@klubovna/api-client';
import { recipeControllerSetRecipe } from '@klubovna/api-client';
import { Product } from '@klubovna/api-client';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { FreestyleDrinkIngredient } from './pos-freestyle-drink-api.model';

export type { FreestyleDrinkIngredient } from './pos-freestyle-drink-api.model';

@Injectable({
  providedIn: 'root',
})
export class PosFreestyleDrinkApiService {
  private http = inject(HttpClient);
  private apiConfig = inject(ApiConfiguration);

  createFreestyleDrink(
    name: string,
    categoryId: string,
    extraCents: number,
    ingredients: FreestyleDrinkIngredient[],
  ): Observable<Product> {
    return productsControllerCreate(
      this.http,
      this.apiConfig.rootUrl,
      {
        body: {
          name,
          categoryId,
          priceCents: 0,
          isActive: true,
        },
      },
    ).pipe(
      map(response => response.body as Product),
      switchMap(product =>
        recipeControllerSetRecipe(
          this.http,
          this.apiConfig.rootUrl,
          {
            id: product.id,
            body: {
              extraCents,
              items: ingredients.map(({ product: ingredient, qty }) => ({
                ingredientId: ingredient.id,
                qty,
              })),
            },
          },
        ).pipe(map(() => product)),
      ),
    );
  }
}
